import { IMessage } from 'types';

export const filterMessagesByType = (messages: Array<IMessage>, type: string): Array<IMessage> => {
  switch (type) {
    case 'student':
      return messages.filter(message => {
        return (
          message.messageType !== 'secure' && message.messageType !== 'agent' && message.messageType !== 'agentStudent'
        );
      });
    case 'agent':
      return messages.filter(message => {
        return message.messageType === 'agent' || message.messageType === 'agentStudent';
      });
    case 'secure':
      return messages.filter(message => {
        return message.messageType === 'secure';
      });
    default:
      return [];
  }
};
